import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as firebase from 'firebase';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  onSubmit(form: NgForm) {
    const fullname = form.value.fullname;
    const spec = form.value.spec;
    const email = form.value.email;
    const password = form.value.password;
    const titula = form.value.titula;

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(userData => {
        return firebase
          .database()
          .ref('users/' + userData.uid)
          .set({
            email: email,
            name: fullname,
            uid: userData.uid,
            spec: spec,
            titula,
            registrationDate: new Date().toDateString()
          })
          .then(() => firebase.auth().signOut());
      })
      .catch(err => {
        // this.notiffer.display("error", err.message);
      });
  }
}
